import { platform } from "utils/api/generated/manucoApi";

// Issue #23 (rechten F4 §4/§5): het audit-spoor en de signalen. Toegang: Beheer (geactiveerd) of Vermogen met bereik
// Alles; met een deelbereik antwoordt de API 403 scope_partial_not_allowed. Die 403 hoort bij deze pagina (melding),
// nooit een doorverwijzing naar /forbidden.

const READ = { retries: 1, suppressAuthRedirect: true };
const WRITE = { retries: 0, suppressAuthRedirect: true };

export const EXPORT_MAX_ROWS = 1000;

// Lege filters weglaten: de API leest "" niet als "geen filter".
function clean(args) {
  const out = {};
  for (const [k, v] of Object.entries(args || {})) {
    if (v === undefined || v === null || v === "") continue;
    out[k] = v;
  }
  return out;
}

// GET /v2/audit/events → { rows, total, offset, maxRows }. from/to = dagen (yyyy-mm-dd), to inclusief.
export async function listAuditEvents(tokenProvider, filters = {}) {
  const res = await platform.auditList(tokenProvider, clean(filters), READ);
  return {
    rows: Array.isArray(res?.rows) ? res.rows : [],
    total: Number(res?.total) || 0,
    offset: Number(res?.offset) || 0,
    maxRows: Number(res?.maxRows) || 0,
  };
}

// GET /v2/audit/alerts?includeSeen=&top=
export async function listAuditAlerts(tokenProvider, { includeSeen = false, top } = {}) {
  const res = await platform.auditAlertList(tokenProvider, clean({ includeSeen: Boolean(includeSeen), top }), READ);
  return Array.isArray(res) ? res : [];
}

// Aantal nieuwe signalen (sidebar-badge Beheer); stil: een fout geeft null.
export async function countNewAuditAlerts(tokenProvider) {
  try {
    const res = await platform.auditAlertList(tokenProvider, { includeSeen: false }, { retries: 0, suppressAuthRedirect: true });
    return (Array.isArray(res) ? res : []).filter((a) => String(a?.status || "NEW").toUpperCase() === "NEW").length;
  } catch {
    return null;
  }
}

// POST /v2/audit/alerts/ack { alertKey, seenThrough } → { alertKey, status, seenThrough, seenAt, seenBy }
// seenThrough = de 'at' van het signaal zoals getoond: komt er later iets bij, dan wordt het weer nieuw.
export function ackAuditAlert(tokenProvider, { alertKey, seenThrough }) {
  return platform.auditAlertAck(tokenProvider, clean({ alertKey, seenThrough }), WRITE);
}
